import React from 'react';
import Carousel from "../components/Carousel";
import store from '../store';

class Instagram extends React.Component {
    componentWillMount() {
        store.dispatch(this.props.fetchInstagramUserID(this.props.home[0].photos.photoUserName)).then(() => {
            store.dispatch(this.props.fetchInstagram(this.props.instagramUserId[0]));
        });
    }
    render(){
        return (
            <div>
                 {this.props.instagram ? <Carousel
                    typeCarousel={"instagram"}
                    slidesToShow={3}
                    sidesToScroll={3} 
                    {...this.props}
                /> : null }
            </div>
        )
    }
}

export default Instagram;


// WEBPACK FOOTER //
// ./src/components/Instagram.js